/**
 * FilterSearch Component
 * Search input for filtering publications
 */

'use client';

import { Search, X } from 'lucide-react';

export interface FilterSearchProps {
  /** Current search query */
  query: string;
  /** Callback when query changes */
  onQueryChange: (value: string) => void;
  /** Placeholder text */
  placeholder?: string;
}

export function FilterSearch({
  query,
  onQueryChange,
  placeholder = 'Search...',
}: FilterSearchProps) {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <input
        type="text"
        value={query}
        onChange={e => onQueryChange(e.target.value)}
        placeholder={placeholder}
        className="h-10 w-full rounded-md border border-input bg-background pl-9 pr-9 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        aria-label="Search publications"
      />
      {query && (
        <button
          type="button"
          onClick={() => onQueryChange('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          aria-label="Clear search"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

